"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9419],{

/***/ 57123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30585);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var formik_material_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24065);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  margin-bottom: 0.5em;\n  display: flex;\n  justify-content: ",
        ";\n  font-size: 12px;\n  .Mui-focusVisible {\n    border: 2px dashed white;\n    outline: 3px dashed #0e3487;\n    outline-offset: 2px;\n  }\n  .MuiTypography-root {\n    font-size: 12px;\n  }\n  .MuiFormControlLabel-label {\n    min-height: 100%;\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .MuiFormControlLabel-label {\n    align-self: center;\n    font-size: 12px;\n    line-height: 1.2;\n    color: ",
        ";\n  }\n  .MuiFormControlLabel-label-273 {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -0.5em;\n  right: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormikCheckboxField__StyledContainer",
    componentId: "sc-37d45bb1-0"
})(_templateObject(), function(p) {
    return p.$isCentered ? "center" : "flex-start";
});
var StyledCheckboxWithLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(formik_material_ui__WEBPACK_IMPORTED_MODULE_3__/* .CheckboxWithLabel */ .$B).withConfig({
    displayName: "FormikCheckboxField__StyledCheckboxWithLabel",
    componentId: "sc-37d45bb1-1"
})(_templateObject1(), function(p) {
    return p.theme.palette.text.secondary;
});
var StyledError = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "FormikCheckboxField__StyledError",
    componentId: "sc-37d45bb1-2"
})(_templateObject2());
var FormikCheckboxField = function(param) {
    var name = param.name, label = param.label, labelStyles = param.labelStyles, required = param.required, inputRef = param.inputRef, isCentered = param.isCentered, className = param.className, classes = param.classes;
    var ref = (0,formik__WEBPACK_IMPORTED_MODULE_2__.useFormikContext)(), errors = ref.errors, touched = ref.touched;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledContainer, {
        $isCentered: isCentered,
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_2__.Field, {
                component: StyledCheckboxWithLabel,
                type: "checkbox",
                color: "primary",
                required: required,
                name: name,
                Label: {
                    label: label,
                    style: {
                        marginLeft: 0
                    }
                },
                inputRef: inputRef,
                inputProps: {
                    "aria-describedby": "".concat(name, "-helper-text")
                },
                classes: classes
            }),
            errors[name] && touched[name] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledError, {
                id: "".concat(name, "-helper-text"),
                error: true,
                children: errors[name]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormikCheckboxField);


/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 71231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);
/* harmony import */ var _pollutionColors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81623);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  margin-top: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 30px;\n  width: 95%;\n  table {\n    width: 100%;\n  }\n  ",
        " {\n    width: 100%;\n    margin-top: 20px;\n  }\n  th,\n  td {\n    border: 1px solid ",
        ";\n    padding: 5px;\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-spacing: 0px;\n  text-align: center;\n  color: ",
        ";\n  thead {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  font-size: 11px;\n  font-weight: 400;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var StyledCaption = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "caption"
}).withConfig({
    displayName: "PollutionTable__StyledCaption",
    componentId: "sc-b5cb80e9-0"
})(_templateObject());
var StyledCellDiv = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PollutionTable__StyledCellDiv",
    componentId: "sc-b5cb80e9-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    displayName: "PollutionTable__StyledTable",
    componentId: "sc-b5cb80e9-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.disable;
}, function(p) {
    return p.theme.colors.borderGrey;
}, function(p) {
    return p.theme.colors.black;
});
var StyledTh = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    displayName: "PollutionTable__StyledTh",
    componentId: "sc-b5cb80e9-3"
})(_templateObject3(), function(p) {
    return p.$minWidth && "min-width: ".concat(p.$minWidth, "px");
});
var PollutionTable = function(param) {
    var data = param.data;
    var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCellDiv, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledTable, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("thead", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                    colSpan: 1,
                                    scope: "colgroup",
                                    children: "דגם"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                    colSpan: 2,
                                    scope: "colgroup",
                                    $minWidth: isDesktop && 220,
                                    children: "צריכת דלק בליטרים ל100 ק״מ*"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                    colSpan: 1,
                                    scope: "colgroup",
                                    children: "דרגת זיהום"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tbody", {
                        children: data === null || data === void 0 ? void 0 : data.pollutionTable.map(function(item, i) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        children: item === null || item === void 0 ? void 0 : item.finishingLevelFullName
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        children: item.fuelConsuption
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        children: item.consuptionType
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        style: {
                                            background: _pollutionColors__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z[item.pullotionLevel - 1],
                                            color: "#FFFFFF"
                                        },
                                        children: item.pullotionLevel
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCaption, {
                children: data.pollutionComment
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PollutionTable);


/***/ }),

/***/ 70554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57833);
/* harmony import */ var _safetyColors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34763);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 30px;\n  width: 95%;\n  ",
        " {\n    width: 100%;\n  }\n  th,\n  td {\n    border: 1px solid ",
        ";\n    padding: 5px;\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-spacing: 0px;\n  text-align: center;\n  width: 100%;\n  color: ",
        ";\n  thead {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 11px;\n  font-weight: 400;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledCellDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SafetyTable__StyledCellDiv",
    componentId: "sc-75f68bbc-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    displayName: "SafetyTable__StyledTable",
    componentId: "sc-75f68bbc-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.disable;
}, function(p) {
    return p.theme.colors.borderGrey;
}, function(p) {
    return p.theme.colors.black;
});
var StyledTh = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    displayName: "SafetyTable__StyledTh",
    componentId: "sc-75f68bbc-2"
})(_templateObject2());
var SafetyTable = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCellDiv, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledTable, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("thead", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                colSpan: 1,
                                scope: "colgroup",
                                children: "קוד דגם"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                colSpan: 1,
                                scope: "colgroup",
                                children: "תיאור דגם"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTh, {
                                colSpan: 1,
                                scope: "colgroup",
                                children: "רמת האבזור הבטיחותי"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tbody", {
                    children: data === null || data === void 0 ? void 0 : data.safetyTable.map(function(item, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                    children: item.finishingLevelCode
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                    children: item.finishingLevelFullName
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                    style: {
                                        background: _safetyColors__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[item.safetyLevel],
                                        color: "#FFFFFF"
                                    },
                                    children: item.safetyLevel
                                })
                            ]
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafetyTable);


/***/ }),

/***/ 81623:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var pollutionColors = [
    "#29503e",
    "#006543",
    "#007a49",
    "#00904b",
    "#00a652",
    "#33992b",
    "#50b849",
    "#fdf100",
    "#ffcb05",
    "#f9a61a",
    "#f48221",
    "#f55820",
    "#d93b20",
    "#ca252c",
    "#ca252c", 
];
/* harmony default export */ __webpack_exports__["Z"] = (pollutionColors);


/***/ }),

/***/ 34763:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var safetyColors = [
    "#a72c31",
    "#f15a23",
    "#ffcb05",
    "#26b78c",
    "#31899f",
    "#238bca",
    "#1b6fb7",
    "#4170b6",
    "#435daa", 
];
/* harmony default export */ __webpack_exports__["Z"] = (safetyColors);


/***/ }),

/***/ 83225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ formsComp_FormSelect; },
  "L": function() { return /* binding */ toFormSelectOptions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js + 1 modules
var InputLabel = __webpack_require__(85161);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/formik-material-ui/dist/formik-material-ui.es6.js + 4 modules
var formik_material_ui_es6 = __webpack_require__(24065);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./common/bit/form/FormikSelect.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .MuiSelect-root {\n      &:focus-visible {\n        border: 2px dashed white;\n        outline: 3px dashed #0e3487;\n        outline-offset: 2px;\n      }\n    }\n\n    ",
        "\n    width: 100%;\n    .MuiFormHelperText-contained {\n      margin-right: 0;\n    }\n    .MuiFormHelperText-root {\n      font-size: 12px;\n    }\n    /* text alignment: */\n    .MuiSelect-outlined.MuiSelect-outlined {\n      text-align: initial;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Styled = {
    Field: (0,styled_components_browser_esm/* default */.ZP)(formik_esm.Field).withConfig({
        displayName: "FormikSelect__Field",
        componentId: "sc-fb0e1fb7-0"
    })(_templateObject(), function(p) {
        return (p === null || p === void 0 ? void 0 : p.$hiddenLabel) && "label { display: none; }";
    })
};
function FormikSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, selectValues = _param.selectValues, map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "selectValues",
        "map",
        "placeholder",
        "hiddenLabel"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled.Field, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        component: formik_material_ui_es6/* TextField */.nv,
        select: true,
        name: name,
        id: name,
        required: required,
        label: label,
        helperText: " ",
        $hiddenLabel: hiddenLabel,
        placeholder: placeholder
    }, props), {
        children: selectValues === null || selectValues === void 0 ? void 0 : selectValues.map(function(value, i) {
            var ref = map(value), name = ref.name, id = ref.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                value: id,
                children: name
            }, i);
        })
    }));
}
/* harmony default export */ var form_FormikSelect = (FormikSelect);

;// CONCATENATED MODULE: ./reusable/formsComp/FormSelect.tsx



function FormSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    FormSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: none !important;\n    font-size: 16px;\n    color: ",
        ";\n    font-weight: 400;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: start;\n    font-size: 12px;\n    margin-top: -23px;\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var FormSelect_Styled = {
    FormControl: (0,styled_components_browser_esm/* default */.ZP)(FormControl/* default */.Z).withConfig({
        displayName: "FormSelect__FormControl",
        componentId: "sc-8af10bf7-0"
    })(FormSelect_templateObject()),
    FieldWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        displayName: "FormSelect__FieldWrapper",
        componentId: "sc-8af10bf7-1"
    })(_templateObject1(), function(p) {
        if ((p === null || p === void 0 ? void 0 : p.$marginTop) === 0) return "0px";
        if (p === null || p === void 0 ? void 0 : p.$marginTop) return p.$marginTop + "px";
        return "22px";
    }),
    InputLabel: (0,styled_components_browser_esm/* default */.ZP)(InputLabel/* default */.Z).withConfig({
        displayName: "FormSelect__InputLabel",
        componentId: "sc-8af10bf7-2"
    })(_templateObject2(), function(p) {
        return p.theme.colors.darkGrey;
    }),
    BottomText: (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
        variant: "body1"
    }).withConfig({
        displayName: "FormSelect__BottomText",
        componentId: "sc-8af10bf7-3"
    })(_templateObject3(), function(p) {
        return p.theme.colors.marbleGrey;
    })
};
var toFormSelectOptions = function(list, idProp, nameProp) {
    return list.map(function(item) {
        return {
            id: item[idProp],
            name: item[nameProp]
        };
    });
};
function FormSelect(_param) {
    var name = _param.name, label = _param.label, _required = _param.required, required = _required === void 0 ? false : _required, values = _param.values, // bottomText,
    map = _param.map, placeholder = _param.placeholder, hiddenLabel = _param.hiddenLabel, marginTop = _param.marginTop, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "values",
        "map",
        "placeholder",
        "hiddenLabel",
        "marginTop"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect_Styled.FieldWrapper, {
            $marginTop: marginTop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_FormikSelect, (0,_object_spread/* default */.Z)({
                label: label,
                name: name,
                required: required,
                selectValues: values,
                hiddenLabel: hiddenLabel,
                map: map,
                placeholder: placeholder
            }, props))
        })
    });
}
/* harmony default export */ var formsComp_FormSelect = (FormSelect);


/***/ })

}]);